import { Component, OnInit, inject } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatOptionModule } from '@angular/material/core';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { AtributoProdutoService } from '../../../../shared/services/apis/produto/atributo-produto.service';
import { AtributoProdutoRequest } from '../../../../shared/services/requests/produto/atributo-produto.request';
import { CampoEquivalenteLookupStruct } from '../../../../shared/services/structs/produto/campo-equivalente-lookup.struct';

@Component({
  selector: 'app-atributo-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    HeaderComponent,
    LoadingBoxComponent,
    FooterActionComponent,
    FormsModule,
  ],
  templateUrl: './atributo-cadastro.component.html',
  styleUrl: './atributo-cadastro.component.css',
})
export class AtributoCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Cadastros;

  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public idAtributo: number = 0;

  public listaCampoEquivalente: CampoEquivalenteLookupStruct[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private atributoService: AtributoProdutoService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.loadLookup();

    this.route.params.subscribe(params => {
      if (params['idAtributo']) {
        this.idAtributo = +params['idAtributo'];
        this.isEdicao = true;
        this.carregarAtributo();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      nome: ['', Validators.required],
      idCampoEquivalenteAtributo: [null],
    });
  }

  private loadLookup(): void {
    this.atributoService.getLookupCampoEquivalente().subscribe({
      next: res => {
        if (res.isError) {
          this.alertService.show(
            'Erro',
            res.errorDescription || 'Erro ao carregar campos equivalentes.',
            AlertType.error
          );
          return;
        }

        this.listaCampoEquivalente = res.list;
      },
      error: err => console.error('Erro ao carregar lookup', err),
    });
  }

  private carregarAtributo(): void {
    this.isLoading = true;
    this.atributoService.getById(this.idAtributo).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show(
            'Erro',
            res.errorDescription || 'Erro ao carregar atributo.',
            AlertType.error
          );
          this.voltar();
          return;
        }

        if (res.atributo) {
          this.form.patchValue({
            nome: res.atributo.nome,
            idCampoEquivalenteAtributo: res.atributo.idCampoEquivalenteAtributo,
          });
        }
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar o atributo.', AlertType.error);
        console.error(err);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.alertService.show('Atenção', 'Verifique os campos obrigatórios.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    const request: AtributoProdutoRequest = {
      nome: this.form.get('nome')?.value,
      idCampoEquivalenteAtributo: this.form.get('idCampoEquivalenteAtributo')?.value,
    };

    if (this.isEdicao) {
      this.atributoService.update(this.idAtributo, request).subscribe({
        next: res => {
          this.tratarRetornoSalvar(res);
        },
        error: err => {
          this.tratarErroSalvar(err);
        },
      });
    } else {
      this.atributoService.create(request).subscribe({
        next: res => {
          this.tratarRetornoSalvar(res);
        },
        error: err => {
          this.tratarErroSalvar(err);
        },
      });
    }
  }

  private tratarRetornoSalvar(res: any): void {
    this.isSaving = false;
    if (res.isError) {
      this.alertService.show(
        'Atenção',
        res.errorDescription || 'Erro ao salvar atributo.',
        AlertType.warning
      );
    } else {
      this.alertService.show('Sucesso', 'Atributo salvo com sucesso.', AlertType.success);
      this.voltar();
    }
  }

  private tratarErroSalvar(err: any): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar.', AlertType.error);
    console.error(err);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/cadastros/atributos-produtos']);
  }
}
